// extracted by mini-css-extract-plugin
export var companyName = "Footer-module--companyName--58dd4";
export var footer = "Footer-module--footer--2d913";
export var footerColumn = "Footer-module--footerColumn--69b37";
export var footerColumnTitle = "Footer-module--footerColumnTitle--97aac";
export var footerColumns = "Footer-module--footerColumns--49cc5";
export var footerText = "Footer-module--footerText--a80e8";
export var footerWrap = "Footer-module--footerWrap--6ba0c";